import { Action, OverlayType } from "./reducer"

import { Dispatch } from "react"
import queryClient from "../../utils/query-client"
import { setCookie } from "../../utils/cookie"

const changeLanguage = (language: string) => {
    setCookie("__language__", language, { sameSite: "Lax" })
    queryClient.removeQueries({
        predicate: query =>
            ["getCart", "getOrder", "getOrders", "getSubscription", "getSubscriptions"].includes(
                query.queryKey[0] as string
            ) && (query.queryKey[1] as { language?: string } | undefined)?.language !== language,
    })
}

const changeRegion = (dispatch: Dispatch<Action>, body: { region: string }) => {
    try {
        setCookie("__region__", body.region, { sameSite: "Lax" })
        dispatch({ type: "PATCH_REGION", payload: { region: body.region } })
    } catch (error) {
        dispatch({ type: "ERROR", error: error })
    }
}

const changeLanguageAndRegion = (dispatch: Dispatch<Action>, body: { language: string; region: string }) => {
    try {
        changeRegion(dispatch, { region: body.region })
        setCookie("__language__", body.language, { sameSite: "Lax" })
    } catch (error) {
        dispatch({ type: "ERROR", error: error })
    }
}

const toggleOverlay = (dispatch: Dispatch<Action>, body: { type: OverlayType }) => {
    dispatch({ type: "TOGGLE_OVERLAY", payload: { type: body.type } })
}

const closeOverlay = (dispatch: Dispatch<Action>, body: { type: OverlayType }) => {
    dispatch({ type: "CLOSE_OVERLAY", payload: { type: body.type } })
}

export { changeLanguage, changeRegion, changeLanguageAndRegion, toggleOverlay, closeOverlay }
